import React, { useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { URLS } from "../urls";
import {  Row } from "react-bootstrap";
import moment from "moment";
import { allMonths, calenderMonths,  useCookie } from "../../utils";
import { toast } from "react-toastify";
import ModalLoader from "../ModalLoader";
import { DialogModal } from "../DialogModal";
import { useComputePayroll } from "./UseComputePayroll";
import TableComponent from "../TableComponent";
import NoTableItem from "../NoTableItem";
import currency from "currency.js";
import { CalendarTodayOutlined } from "@mui/icons-material";
import { SalarySetting } from "./SalarySetting";
import { SummaryChartIconUp } from "../icons";

export function ProcessFullAndFinally(
  { show, handleClose, details, reload, theCompanySettings },
  props
) {
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const branch_id = useCookie("branch_id");

  const date = new Date();
  const [payrollDate, setPayrollDate] = useState({
    payrollMonth: "",
    payrollYear: date.getFullYear(),
  });

  const memoizedQueryParams = useMemo(
    () => ({ id: details?.employeeId }),
    [details?.employeeId]
  );
  const memoizedExcelData = useMemo(() => [], []);

  const {
    normalEmployees,
    // searchItems,
    IsFetching,
    settingHeaders,
    returnParams,
    totalbenefit,
    totalallowance,
    totalbonus,
    totalGross,
    totalDeduct,
    totalNet,
    companySettings,
    deductionSettings,
    bonusSettings,
    allownaceSettings,
    benefitSettings,
    pendingRetirement,
    customHeaders,
    DeductionGroupName,
    BonusGroupName,
    AllowanceGroupName,
    BenefitGroupName,
    // payrollSetting,
    payrollCycle,
    // calculateEmployeePayroll,
    // setNormalEmployees,
  } = useComputePayroll({
    payrollDate,
    queryParams: memoizedQueryParams,
    fullAndFinally: true,
    theexcelData: memoizedExcelData,
  });

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th>No</th>
          <th>Name</th>
          <th>Employees ID</th>

          <th>Job Grade</th>
          <th>Join Date</th>
          <th>Days Committed</th>
          {companySettings?.extras ? (
            <>
              <th>Days On</th>
              <th>Transit Days</th>
              <th>Overstay Days</th>
              <th>Arrears Days</th>
            </>
          ) : null}

          <th>Location</th>
          <th>LSP</th>

          <th>Gross Salary</th>
          {Object.entries(settingHeaders).length === 0 ||
          settingHeaders?.basic ? (
            <th>Basic</th>
          ) : null}
          {Object.entries(settingHeaders).length === 0 ||
          settingHeaders?.housing ? (
            <th>Housing</th>
          ) : null}
          {Object.entries(settingHeaders).length === 0 ||
          settingHeaders?.transport ? (
            <th>Transport</th>
          ) : null}
          {Object.entries(settingHeaders).length === 0 ||
          settingHeaders?.medical ? (
            <th>Medical</th>
          ) : null}
          {Object.entries(settingHeaders).length === 0 ||
          settingHeaders?.utility ? (
            <th>Utility</th>
          ) : null}
          {Object.entries(settingHeaders).length === 0 ||
          settingHeaders?.entertainment ? (
            <th>Entertainment</th>
          ) : null}
          {Object.entries(settingHeaders).length === 0 ||
          settingHeaders?.dressing ? (
            <th>Dressing</th>
          ) : null}
          {customHeaders.map((el) => (
            <th>{el}</th>
          ))}
          <th>Earned Gross Salary</th>
          {deductionSettings
            .filter((el) => !el.groupName)
            .map((setting, index) => {
              return (
                <th className="text-capitalize" key={index}>
                  {setting.name === "company pension"
                    ? "Employer pension contribution"
                    : setting.name === "pension"
                    ? "Employee pension contribution"
                    : setting.name}
                  <SalarySetting setting={setting} />
                  <br />
                </th>
              );
            })}
          {DeductionGroupName.map((setting, index) => {
            return (
              <th className="text-capitalize" key={index}>
                {setting}
                <br />{" "}
              </th>
            );
          })}

          {bonusSettings
            .filter((el) => !el.groupName)
            .map((setting, index) => {
              return (
                <th className="text-capitalize" key={index}>
                  {setting.name} <SalarySetting setting={setting} />
                  <br />
                </th>
              );
            })}

          {BonusGroupName.map((setting, index) => {
            return (
              <th className="text-capitalize" key={index}>
                {setting}
                <br />{" "}
              </th>
            );
          })}

          {allownaceSettings
            .filter((el) => !el.groupName)
            .map((setting, index) => {
              return (
                <th className="text-capitalize" key={index}>
                  {setting.name} <SalarySetting setting={setting} />
                  <br />{" "}
                </th>
              );
            })}
          {AllowanceGroupName.map((setting, index) => {
            return (
              <th className="text-capitalize" key={index}>
                {setting}
                <br />{" "}
              </th>
            );
          })}
          {benefitSettings
            .filter((el) => !el.groupName)
            .map((setting, index) => {
              return (
                <th className="text-capitalize" key={index}>
                  {setting.name} <SalarySetting setting={setting} />
                  <br />{" "}
                </th>
              );
            })}
          {BenefitGroupName.map((setting, index) => {
            return (
              <th className="text-capitalize" key={index}>
                {setting}
                <br />{" "}
              </th>
            );
          })}
          {/* <th>Other Deductions</th> */}
          <th>Loan Deductions</th>
          {pendingRetirement?.length > 0 && <th>IOU Deductions</th>}
          <th>Attendance Deduction</th>
          <th>Total Deductions</th>
          <th>Total Bonus</th>
          <th>Total Allowance</th>
          <th>Total Benefit</th>
          <th>Net Pay</th>
        </tr>
      </thead>
    );
  };

  const tableBodyData = (employee, index) => {
    return (
      <>
        <td>{returnParams?.startIndex + index + 1}</td>

        <td>{employee?.name.first + " " + employee.name.last}</td>
        <td>{employee.employeeId}</td>

        <td>{employee.gradeName}</td>

        <td className="d-flex gap-3 align-items-baseline">
          {" "}
          <span>
            {" "}
            <CalendarTodayOutlined fontSize="small" />{" "}
          </span>{" "}
          <p>
            {moment(employee?.startDate, "DD/MM/YYYY")?.format("Do MMMM YYYY")}
          </p>{" "}
        </td>
        <td>
          {employee?.totalDaysWorked === "" ? 0 : employee?.totalDaysWorked}
        </td>
        {companySettings?.extras ? (
          <>
            <td>
              {employee?.userExtras?.DayOn === ""
                ? 0
                : employee?.userExtras?.DayOn}
            </td>
            <td>
              {employee?.userExtras?.TransitDays === ""
                ? 0
                : employee?.userExtras?.TransitDays}
            </td>
            <td>
              {employee?.userExtras?.OverStayDays === ""
                ? 0
                : employee?.userExtras?.OverStayDays}
            </td>
            <td>
              {employee?.userExtras?.ArrearsDays === ""
                ? 0
                : employee?.userExtras?.ArrearsDays}
            </td>
          </>
        ) : null}

        <td>{employee.usedlocation}</td>
        <td>{employee.usedcontract}</td>
        <td>
          {currency(employee.grossPay, {
            symbol: "",
          }).format()}
        </td>
        {Object.entries(settingHeaders).length === 0 ||
        settingHeaders?.basic ? (
          <td>
            {currency(employee.basic, {
              symbol: "",
            }).format()}
          </td>
        ) : null}
        {Object.entries(settingHeaders).length === 0 ||
        settingHeaders?.housing ? (
          <td>
            {currency(employee.housing, {
              symbol: "",
            }).format()}
          </td>
        ) : null}
        {Object.entries(settingHeaders).length === 0 ||
        settingHeaders?.transport ? (
          <td>
            {currency(employee.transport, {
              symbol: "",
            }).format()}
          </td>
        ) : null}
        {Object.entries(settingHeaders).length === 0 ||
        settingHeaders?.medical ? (
          <td>
            {currency(employee.medical, {
              symbol: "",
            }).format()}
          </td>
        ) : null}
        {Object.entries(settingHeaders).length === 0 ||
        settingHeaders?.utility ? (
          <td>
            {currency(employee.utility, {
              symbol: "",
            }).format()}
          </td>
        ) : null}
        {Object.entries(settingHeaders).length === 0 ||
        settingHeaders?.entertainment ? (
          <td>
            {currency(employee.entertainment, {
              symbol: "",
            }).format()}
          </td>
        ) : null}
        {Object.entries(settingHeaders).length === 0 ||
        settingHeaders?.dressing ? (
          <td>
            {currency(employee.dressing, {
              symbol: "",
            }).format()}
          </td>
        ) : null}
        {employee?.custom?.map((el) => (
          <td>
            {currency(el?.value, {
              symbol: "",
            }).format()}
          </td>
        ))}

        <td>
          {currency(employee.ogGrossPay, {
            symbol: "",
          }).format()}
        </td>
        {deductionSettings
          .filter((el) => !el.groupName)
          .map((e, i) => {
            return (
              <td key={i}>
                {currency(
                  employee.deductions.find((el) => el.slug === e.slug)?.total,
                  {
                    symbol: "",
                  }
                ).format()}
              </td>
            );
          })}
        {DeductionGroupName.map((e, i) => {
          return (
            <td key={i}>
              {currency(
                employee.deductions
                  .filter((el) => el.groupName === e)
                  .map((el) => el.total)
                  .reduce((a, b) => a + b, 0),
                {
                  symbol: "",
                }
              ).format()}
            </td>
          );
        })}

        {bonusSettings
          .filter((el) => !el.groupName)
          .map((e, i) => {
            return (
              <td key={i}>
                {currency(
                  employee.bonus.find((el) => el.slug === e.slug)?.total,
                  {
                    symbol: "",
                  }
                ).format()}
              </td>
            );
          })}
        {BonusGroupName.map((e, i) => {
          return (
            <td key={i}>
              {currency(
                employee.bonus
                  .filter((el) => el.groupName === e)
                  .map((el) => el.total)
                  .reduce((a, b) => a + b, 0),
                {
                  symbol: "",
                }
              ).format()}
            </td>
          );
        })}
        {allownaceSettings
          .filter((el) => !el.groupName)
          .map((e, i) => {
            return (
              <td key={i}>
                {currency(
                  employee.allowances.find((el) => el.slug === e.slug)?.total,
                  {
                    symbol: "",
                  }
                ).format()}
              </td>
            );
          })}
        {AllowanceGroupName.map((e, i) => {
          return (
            <td key={i}>
              {currency(
                employee.allowances
                  .filter((el) => el.groupName === e)
                  .map((el) => el.total)
                  .reduce((a, b) => a + b, 0),
                {
                  symbol: "",
                }
              ).format()}
            </td>
          );
        })}
        {benefitSettings
          .filter((el) => !el.groupName)
          .map((e, i) => {
            return (
              <td key={i}>
                {currency(
                  employee.benefits.find((el) => el.slug === e.slug)?.total,
                  {
                    symbol: "",
                  }
                ).format()}
              </td>
            );
          })}
        {BenefitGroupName.map((e, i) => {
          return (
            <td key={i}>
              {currency(
                employee.benefits
                  .filter((el) => el.groupName === e)
                  .map((el) => el.total)
                  .reduce((a, b) => a + b, 0),
                {
                  symbol: "",
                }
              ).format()}
            </td>
          );
        })}

        <td>
          {employee.loanDeduct
            ? currency(employee.loanDeduct, {
                symbol: "",
              }).format()
            : 0}
        </td>
        {pendingRetirement?.length > 0 && (
          <td>
            {employee.remainingRetairment
              ? currency(employee.remainingRetairment, {
                  symbol: "",
                }).format()
              : 0}
          </td>
        )}
        <td>
          {currency(employee.attendanceTotal, {
            symbol: "",
          }).format()}
        </td>
        <td>
          {currency(employee.allTotalDeduction, {
            symbol: "",
          }).format()}
        </td>
        <td>
          {currency(employee.totalBonus, {
            symbol: "",
          }).format()}
        </td>
        <td>
          {currency(employee.totalAllowances, {
            symbol: "",
          }).format()}
        </td>
        <td>
          {currency(employee.totalBenefits, {
            symbol: "",
          }).format()}
        </td>
        <td>
          {currency(employee.netPay, {
            symbol: "",
          }).format()}
        </td>
      </>
    );
  };

  const sendAction = async () => {
    try {
      setIsLoading(true);

      const formData = new FormData();

      let nE = normalEmployees.map((employee) => {
        return {
          ...employee,
          payrollMonth: payrollDate.payrollMonth,
          payrollYear: payrollDate.payrollYear,
          debitAccountNo: theCompanySettings?.debitAccountNumber,
          debitBankCode: theCompanySettings?.debitBankCode,
          type: "normal",
          settingHeaders,
          fullAndFinally: true,
        };
      });
      setOpenDialog(false);
      formData.append(
        "payload",
        JSON.stringify({
          payroll: [...nE],
          payrollMonth: payrollDate.payrollMonth,
          payrollYear: payrollDate.payrollYear,
          companySettings,
          branch_id,
          employeeType: "All",
          category: "",
          fullAndFinally: true,
        })
      );

      await fetch(`${URLS.backendPayroll}/save-payroll-by-branch`, {
        method: "POST",
        body: formData,
      });
      toast("payroll created", {
        type: "success",
        position: "top-right",
      });
    } catch (error) {
      console.log(error);
      toast.error("Error !!! ", error.massage || "");
    } finally {
      setIsLoading(false);
      setOpenDialog(false);
      handleClose();
      reload();
    }
  };

  return (
    <Modal
      {...props}
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="custom-wide-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Process Full and Finally for {details?.employeeName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="my-3">
          <div className="d-flex my-4">
            <div className="form-inline">
              <label>Select Month</label>
              <select
                className="form-control mx-2"
                value={payrollDate.payrollMonth}
                onChange={(e) =>
                  setPayrollDate({
                    payrollMonth: e.target.value,
                    payrollYear: payrollDate.payrollYear,
                  })
                }
              >
                <option value="">Select Month</option>
                {calenderMonths().map((e, index) => (
                  <option key={index} value={index + 1}>
                    {e}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-inline ml-3">
              <label>Select Year</label>
              <input
                type="number"
                style={{ width: "100px" }}
                className="form-control mx-2"
                value={payrollDate.payrollYear}
                onChange={(e) =>
                  setPayrollDate({
                    payrollMonth: payrollDate.payrollMonth,
                    payrollYear: e.target.value,
                  })
                }
              />
            </div>
            {payrollDate.payrollMonth ? (
              <div className="mx-4">
                <label>{""} </label>
                <div>
                  <b>
                    Payroll Cycle from{" "}
                    {moment(payrollCycle.payrollStartDate).format(
                      "Do MMMM YYYY"
                    )}{" "}
                    to{" "}
                    {moment(payrollCycle.payrollEndDate).format("Do MMMM YYYY")}
                  </b>
                </div>
              </div>
            ) : null}
          </div>

          <div className="mx-4">
            {IsFetching ? (
              <ModalLoader show={IsFetching} />
            ) : (
              <>
                {normalEmployees?.length > 0 && payrollDate.payrollMonth ? (
                  <Row className="table-height">
                    <TableComponent
                      responsive
                      striped
                      sticky
                      tableHeadsFunction={tableHead}
                      mainDataArray={normalEmployees}
                      tableDataRowFunction={tableBodyData}
                      className="product-table text-nowrap"
                    />
                  </Row>
                ) : (
                  <NoTableItem
                    title={
                      payrollDate.payrollMonth
                        ? `No data on ${
                            allMonths[payrollDate.payrollMonth - 1]
                          } ${payrollDate.payrollYear}`
                        : "Please Select the month for payroll"
                    }
                  />
                )}
              </>
            )}
          </div>

          {payrollDate.payrollMonth ? (
            <div className="my-4">
              <button
                onClick={() => setOpenDialog(true)}
                className="btn btn-primary"
              >
                Proceed
              </button>
            </div>
          ) : null}
        </div>

        <div>
          <div className={`summaryNew border-top`}>
            <div className="row justify-content-between mt-4">
              <div className="col">
                <div className="my-3">
                  <div className="d-flex gap-3 align-items-center mb-4">
                    <h4 className="m-0">Payroll Summary</h4>{" "}
                    <hr className="flex-grow-1 m-0" />
                   
                  </div>

                  <div
                    className="gridCont mb-3 three-col-grid"
                    style={{ gridTemplateRows: "unset" }}
                  >
                    {/*  */}
                    <div className="gridChild gridChildBorderLeftBlue">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(totalGross, {
                            symbol: "",
                          }).format()}
                        </p>
                        <p className="gridChld2">Total Earned Gross</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>

                    {/*  */}

                    <div className="gridChild gridChildBorderLeftDarkerGreen">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(totalallowance, {
                            symbol: "",
                          }).format()}
                        </p>
                        <p className="gridChld2">Total Allowance</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>
                    {/*  */}

                    <div className="gridChild gridChildBorderLeftDarkerGreen">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(totalbenefit, {
                            symbol: "",
                          }).format()}
                        </p>
                        <p className="gridChld2">Total Benefit</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>
                    {/*  */}
                  </div>

                  {/* Secound Order */}

                  <div
                    className="gridCont mb-3 three-col-grid"
                    style={{ gridTemplateRows: "unset" }}
                  >
                    {/*  */}
                    <div className="gridChild gridChildBorderLeftDarkerGreen">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(totalbonus, {
                            symbol: "",
                          }).format()}
                        </p>
                        <p className="gridChld2">Total Bouns</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>
                    {/*  */}

                    <div className="gridChild gridChildBorderLeftOrange">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(totalDeduct, {
                            symbol: "",
                          }).format()}
                        </p>
                        <p className="gridChld2">Total Deduction</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>
                    {/*  */}

                    <div className="gridChild gridChildBorderLeftDarkerGreen">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(totalNet, {
                            symbol: "",
                          }).format()}
                        </p>
                        <p className="gridChld2">Total Net Amount</p>
                      </div>

                      <div className="gridChildRight">
                        <SummaryChartIconUp />
                        <p>5%</p>
                      </div>
                    </div>
                    {/*  */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      {openDialog && (
        <DialogModal
          show={openDialog}
          proceed={sendAction}
          handleClose={() => setOpenDialog(false)}
          title="Process Full and Finally"
          description={`Are you sure you want to process Process Full and Finally for ${
            details?.employeeName
          } for the month of ${allMonths[payrollDate.payrollMonth - 1]} ${
            payrollDate.payrollYear
          } `}
          sendTitle="Proceed"
        />
      )}

      <ModalLoader show={isLoading} />
    </Modal>
  );
}
